<!-- eslint-disable vue/valid-template-root -->
<script>
import { mapGetters } from "vuex";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";

export default {
  name: "WelcomePanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
  },

  data() {
    return {
      clientConfig,
    };
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",

      "acceptedDisclaimer",
    ]),
  },

  methods: {
    textLinkClick(event) {
      if (event.target.closest(".disclaimer-link")) {
        this.clickToTab(6);
      } else if (event.target.closest(".assumptions-link")) {
        this.clickToTab(7);
      }
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.lastActiveTab],
        calculator_step: "Continue",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.lastActiveTab] + 
          ", calculator_step: Continue"
        );


      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },

    toggleAcceptDisclaimer() {
      this.$store.commit("setAcceptDisclaimer", !this.acceptedDisclaimer);
    },
  },

  mounted() {},
};
</script>

<template>
  <div class="welcome-panel">
    <div class="panel-header px-4 px-md-5">
      <div class="client-logo" alt="Foresters Financial logo"></div>
    </div>
    <div class="panel-content">
      <MDBContainer fluid class="content-shift">
        <MDBRow class="p-0">
          <MDBCol md="9" class="welcome-content px-4 px-md-4">
            <div class="intro-text">
              <div v-html="clientConfig.content.welcome.bannerHeading"></div>
              <div v-html="clientConfig.content.welcome.content"></div>
              <br />
              <div>
                <input
                  class="acceptCheckbox"
                  type="checkbox"
                  name="acceptDisclaimer"
                  id="acceptDisclaimer"
                  value="1"
                  :checked="acceptedDisclaimer"
                  @click="toggleAcceptDisclaimer()"
                />
                <div class="acceptCheckboxText" @click="textLinkClick" v-html="clientConfig.content.welcome.acceptanceText"></div>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="9">
            <MDBRow class="mt-4 mt-lg-2">
              <MDBCol class="mx-auto my-4 mx-md-3 px-4 px-lg-4 text-center text-md-start">
                <MDBBtn
                  :disabled="!acceptedDisclaimer"
                  class="btn-primary"
                  @click="clickToTab(2)"
                  aria-label="Get started button"
                >
                  {{ clientConfig.content.welcome.buttonLabel }}
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
    <!-- <div class="panel-footer"></div> -->
  </div>
</template>
